module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/General/Fire-b22276d49f80a30e8f20a04bd8fbf262c806bdb372d79e3d474643bdfbbf7228.svg";